import React, { useEffect, useState } from 'react';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm'
import { Nav } from 'react-bootstrap';
import './CustomSidePane.scss';

function parseTextStyles(text) {
  if (!text || typeof text !== 'string') return text;

  const parts = text.split(/(\*\*[^*]+\*\*|__[^_]+__)/g);

  return parts.map((part, i) => {
    if (part.startsWith('**') && part.endsWith('**')) {
      return <strong key={i}>{part.slice(2, -2)}</strong>;
    }
    if (part.startsWith('__') && part.endsWith('__')) {
      return <em key={i}>{part.slice(2, -2)}</em>;
    }
    return part;
  });
}

function ActivePage ({ content }) {
  const header = content?.find(item => item.type === 'header')?.body;

  const renderType = (item, index) => {
    const { type, body } = item;

    switch (type) {
      case 'divider':
        return <span key={index} className='pt-3'></span>;
      case 'header':
        return (
          <div key={index} className='d-flex flex-column mb-2'>
            <h5>{parseTextStyles(body)}</h5>
            <span style={{ borderTop: '1px solid gray', width: '100%', opacity: 0.5 }}></span>
          </div>
        );
      case 'subHeader':
        return <h6 key={index}>{parseTextStyles(body)}</h6>;
      case 'message':
        return <p key={index} className='pb-2'>{parseTextStyles(body)}</p>;
      case 'video':
        return (
          <video key={index} autoPlay loop muted playsInline controls className='video pb-2'>
            <source src={body} type="video/mp4" />
          </video>
        );
      case 'imageSrc':
        return <img className='pb-2' key={index} src={body} alt={`${header}`} style={{ width: '100%', height: 'auto', marginBottom: '8px' }} />;
      case 'markdown':
        return (
          <div className='pb-2'>
            <Markdown
              remarkPlugins={[remarkGfm]}
              components={{
                table: (props) => <table style={{ borderCollapse: 'collapse' }} {...props} />,
                th: (props) => <th style={{ border: '1px solid #ccc', padding: '8px' }} {...props} />,
                td: (props) => <td style={{ border: '1px solid #ccc', padding: '8px' }} {...props} />
              }}
            >
              {body}
            </Markdown>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className='content-wrapper'>
      <article className='d-flex flex-column'>
        {content?.map((item, index) => renderType(item, index))}
      </article>
    </div>
  )
}

function CustomSidePane ({ showSidePane, sidePaneContent = [], modalHeight }) {

  const [navPages, setNavPages] = useState([]);
  const [activePage, setActivePage] = useState(null);

  useEffect(() => [
    setActivePage(showSidePane ? navPages?.[0]?.key ?? null : null)
  ], [showSidePane, navPages])

  useEffect(() => {
    if (sidePaneContent.length <= 0) { return };
    const nav = sidePaneContent.map(content => ({ key: content?.key, name: content?.name }));
    setNavPages(nav);
  }, [sidePaneContent]);

  return (
    <div className={showSidePane ? "show-side-pane col" : "hide-side-pane col"} style={{ maxHeight: modalHeight }}>
      <Nav
        variant="tabs"
        defaultActiveKey={activePage}
        activeKey={activePage}
        onSelect={(key) => setActivePage(key)}
        id='custom-side-pane-nav'
        className='hide-scrollbar'
      >
        {navPages.map(page => {
          const { key, name } = page;
          return (
            <Nav.Item key={key}>
              <Nav.Link eventKey={key}>{name}</Nav.Link>
            </Nav.Item>
          ) 
        })}
    </Nav>

    <ActivePage content={sidePaneContent.find(page => page?.key === activePage)?.content} />
      
    </div>
  )
}

export default CustomSidePane;
